import { FC, useRef, useState } from 'react';
import { useClickAway } from 'react-use';

export interface DropDownItemType {
  label: string;
  item: any;
}

export interface DropDownWithCurrentSelectionProps {
  currentSelectionLabel: string;
  dropDownItems: DropDownItemType[];
  selectDropDownItem: (key: string, dropDownItems: DropDownItemType[]) => void;
}

const DropDownWithCurrentSelection: FC<DropDownWithCurrentSelectionProps> = ({
  currentSelectionLabel,
  dropDownItems,
  selectDropDownItem
}) => {
  const ref = useRef(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  useClickAway(ref, () => setIsDropdownOpen(false));

  const currentSelectedItem = dropDownItems.find(
    (items) => items.item === currentSelectionLabel
  );

  return (
    <>
      <div className="block relative" ref={ref}>
        <button
          aria-haspopup="true"
          aria-controls="dropdown-menu"
          onClick={() => setIsDropdownOpen(!isDropdownOpen)}
          className="px-2 py-2"
        >
          <span className="text-sm px-4 py-2 rounded border border-neutral-400 items-center">
            {currentSelectedItem?.label ?? 'Not yet set'}
            <i className="ml-4 pt-2 ra-icons-generic-down-arrow text-bottom text-xs"></i>
          </span>
        </button>

        {isDropdownOpen ? (
          <div
            className={`absolute z-40 min-w-fit md:right-0 w-full drop-shadow-xl rounded`}
            id="dropdown-menu-with-current-selection"
            role="menu"
          >
            <div className="py-1 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5">
              {dropDownItems.map((item, index) => (
                <div
                  key={`${item.item}-dropdown-with-current-selection-${index}`}
                  className="block px-4 py-2 text-sm hover:bg-secondary-50 cursor-pointer"
                  onClick={() => {
                    selectDropDownItem(item.item, dropDownItems);
                    setIsDropdownOpen(false);
                  }}
                >
                  {item.label}
                </div>
              ))}
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};

export default DropDownWithCurrentSelection;
